"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const defaultOptions = {
  is24HourFormat: false,
  locale: 'es'
};

/**
 * Retrieves the hours component of a given date based on the specified options.
 *
 * @param {Time} date - The date to retrieve hours from.
 * @param {HourOptions} [options=defaultOptions] - Options for configuring the hour format and locale.
 * @returns {string | number} - The hours (e.g., 23 for 11 PM in 24-hour format, or "11 PM" in 12-hour format).
 *
 * @example
 * const hours24 = getHour(new Date(), { is24HourFormat: true }) // e.g., 23
 * const hours12 = getHour(new Date(), { is24HourFormat: false }) // e.g., 11PM
 */
function getHour() {
  var _amPmMap$locale, _amPmMap$locale2;
  let date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Date();
  let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultOptions;
  const {
    is24HourFormat,
    locale
  } = _objectSpread(_objectSpread({}, defaultOptions), options);
  const hours = date.getHours();
  const amPmMap = {
    en: {
      am: 'AM',
      pm: 'PM'
    },
    es: {
      am: 'am',
      pm: 'pm'
    },
    fr: {
      am: 'AM',
      pm: 'PM'
    }
  };
  if (is24HourFormat) return hours;
  const period = hours >= 12 ? ((_amPmMap$locale = amPmMap[locale]) === null || _amPmMap$locale === void 0 ? void 0 : _amPmMap$locale.pm) || 'PM' : ((_amPmMap$locale2 = amPmMap[locale]) === null || _amPmMap$locale2 === void 0 ? void 0 : _amPmMap$locale2.am) || 'AM';
  const hour12 = hours % 12 || 12;
  return "".concat(hour12).concat(period);
}
var _default = exports.default = getHour;